export default "__VITE_ASSET__e541LuBn__"